import { FC, useCallback, useMemo } from 'react';
import getConfig from 'next/config';
import dynamic from 'next/dynamic';
import { Spinner } from '@sravni/react-design-system';
import { useRouter } from 'next/router';
import { Container } from '../../../landing.common';
import { isProduction } from '../../../../helpers';
import { AMOUNT_LIMITS, FORM_FIELDS } from '../../../../constants';
import { CustomButton } from './custom.button';
import styles from './styles.module.scss';
import { DEFAULT_RATE } from './consts';

interface IProps {
    landingData: FE.FormData;
    setLandingData: (landingData: FE.FormData) => void;
}

const SelectionCalculator = dynamic(import('./calculator.client'), {
    ssr: false,
    loading: () => (
        <div className={styles.calculatorLoader}>
            <Spinner size={28} />
        </div>
    ),
});

export const Calculator: FC<IProps> = (props) => {
    const { landingData, setLandingData } = props;
    const router = useRouter();

    const isOnlajnZayavkaKredit = useMemo(() => {
        const path = router.asPath.split('?')[0];
        return path === '/kredity/onlajn-zayavka-na-kredit' || path === '/kredity/onlajn-zayavka-na-kredit/';
    }, [router.asPath]);

    const onChange = useCallback(
        (field: string, value: any) => {
            setLandingData({
                [field]: value,
            });
        },
        [setLandingData],
    );

    return (
        <Container className={styles.calculator}>
            <SelectionCalculator
                renderSubmitButton={
                    isOnlajnZayavkaKredit ? () => <CustomButton landingData={landingData} /> : undefined
                }
                isLoggedIn={false}
                isLoggedInEsia={false}
                baseUrl={getConfig().publicRuntimeConfig.webPath}
                enableAnalytics={isProduction ? true : 'logs'}
                eventLabelPage="Лендинг подбора"
                defaultFormValues={{
                    amount: landingData[FORM_FIELDS.AMOUNT],
                    period: landingData[FORM_FIELDS.PERIOD],
                    purpose: landingData[FORM_FIELDS.PURPOSE],
                    rate: DEFAULT_RATE,
                }}
                onFieldChange={onChange}
                formParams={{
                    amount: {
                        min: AMOUNT_LIMITS.MIN,
                        max: AMOUNT_LIMITS.MAX,
                        step: 50_000,
                    },
                }}
            />
        </Container>
    );
};
